// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"styles_colorPicker__2pw94","inputDisplay":"styles_inputDisplay__1AgVI"};